<script setup lang="ts">
import { watch } from 'vue'
import { storeToRefs } from 'pinia'

import { KsIcon } from '@aschehoug/kloss'
import { useAuthStore } from '@/stores/auth'

import Typography from '@/components/common/Typography.vue'
import { useLicenseStore } from '@/stores/license'

const { isAuthenticated } = storeToRefs(useAuthStore())
const licenseStore = useLicenseStore()

watch(() => licenseStore.shouldShowLicenseAlert, (newValue) => {
  document.body.style.overflow = newValue ? 'hidden' : 'auto'
})
</script>

<template>
  <div
    v-if="licenseStore.shouldShowLicenseAlert"
    class="license-control-overlay"
  >
    <div class="license-control-content">
      <div :class="['banner', isAuthenticated && 'border-only']">
        <template v-if="!isAuthenticated">
          <Typography class="banner-text">
            {{ $t('readTheWholeArticle') }}
          </Typography>
          <KsIcon
            id="arrow-right"
            size="large"
            aria-hidden="true"
          />
        </template>
      </div>
      <div class="text">
        <Typography
          class="banner-text"
          variant="h3"
          component="h1"
        >
          {{ $t('youDoNotHaveAccessToThisContent') }}
        </Typography>
        <div class="actions">
          <span>
            {{ $t('doYouWantAccessToMoreContent') }}
          </span>
          <CommonButton>
            {{ $t('orderTestLicense') }}
          </CommonButton>
        </div>
      </div>
      <div class="banner bottom">
        <CommonButton
          decoration="underline"
          to="/"
        >
          {{ $t('goToFrontPage') }}
        </CommonButton>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .banner-text {
    margin: 0;
  }

  .license-control-overlay {
    z-index: 998;
    position: fixed;
    background: linear-gradient(to bottom, rgb(255 255 255 / 40%) 0%, white 70%, white 50%);
    inset: 0;
  }

  .license-control-content {
    z-index: 999;
    position: fixed;
    inset: auto 0 0;
    min-height: 458px;
    background-color: var(--color-white);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;
    gap: 16px;
  }

  .text {
    display: grid;
    gap: 8px;
  }

  .actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
  }

  .license-control-content > * {
    padding: 16px;
  }

  .banner {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--color-blue-60);
    color: var(--color-lightblue-10);
    gap: 8px;
    padding: 16px;
    text-align: left;
  }

  .border-only {
    height: 1px;
    padding: 0;
  }

  .bottom {
    background-color: var(--color-lightblue-10);
    color: var(--color-blue-60);
  }

  svg {
    rotate: 90deg;
  }
</style>
